import * as React from "react";
import { alpha, styled } from "@mui/material/styles";
import InputLabel from "@mui/material/InputLabel";
import TextField from "@mui/material/TextField";
import TextArea from "antd/lib/input/TextArea";
import {
  colors,
  FormControl,
  IconButton,
  InputAdornment,
  OutlinedInput,
  Select,
} from "@mui/material";
import InputBase from "@mui/material/InputBase";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { MuiPhoneNumber } from "material-ui-phone-number";
import { DatePicker, DateTimePicker } from "@mui/x-date-pickers";

/** Primary CTA — readable in both dark and light (never use --secColor4 on red). */
export const main_button = {
  color: "#ffeaea !important",
  bgcolor: "#7D010C",
  background: "linear-gradient(160deg, rgba(125,1,12,0.92), rgba(74,1,7,0.88))",
  border: "1px solid rgba(190,50,62,0.45)",
  boxShadow: "inset 0 1px 0 rgba(255,255,255,0.18), 0 8px 22px rgba(125,1,12,0.40)",
  ":hover": {
    color: "#ffeaea !important",
    bgcolor: "#9c0410",
    background: "linear-gradient(160deg, rgba(156,4,16,0.95), rgba(100,1,10,0.90))",
  },
  ":disabled": {
    color: "var(--mut) !important",
    bgcolor: "var(--s08) !important",
    background: "var(--s08) !important",
    border: "1px solid var(--s10)",
    boxShadow: "none",
  },
  borderRadius: "999px",
  fontWeight: 600,
  textTransform: "none",
  padding: "8px 18px",
};

/** Secondary / outline-style action */
export const sec_button = {
  color: "var(--tx2) !important",
  bgcolor: "var(--s03)",
  background: "var(--s03)",
  border: "1px solid var(--s14)",
  ":hover": {
    color: "var(--tx) !important",
    bgcolor: "var(--s08)",
    background: "var(--s08)",
  },
  ":disabled": {
    color: "var(--mut) !important",
    bgcolor: "var(--s03)",
  },
  borderRadius: "999px",
  fontWeight: 600,
  textTransform: "none",
  padding: "8px 18px",
};

export const ter_button = {
  color: "var(--appBg)",
  bgcolor: "var(--accColor)",
  ":hover": {
    color: "var(--accColor)",
    bgcolor: "var(--appBg)",
  },
  ":disabled": {
    color: "var(--appBg)",
    bgcolor: "gray",
  },
  borderRadius: 3,
  fontWeight: "bold",
  padding: 1,
};

export const confirm_button = {
  color: "var(--mainWhite)",
  bgcolor: "green",
  ":hover": {
    bgcolor: "lightgreen",
    color: "green",
  },
  ":disabled": {
    color: "var(--mainWhite)",
    bgcolor: "gray",
  },
  borderRadius: 0,
  fontWeight: "bold",
  padding: 1,
};

export const reject_button = {
  color: "white !important",
  bgcolor: "red !important",
  ":hover": {
    bgcolor: "white !important",
    color: "red !important",
  },
  ":disabled": {
    color: "white !important",
    bgcolor: "gray !important",
  },
  borderRadius: 0,
  fontWeight: "bold",
  padding: 1,
};

export const card_style = {
  padding: 2,
  marginY: 2,
  marginX: 2,
  ":hover": {
    "transition-duration": "0.5s",
    "box-shadow": "0px 5px 5px 0px rgba(15,44,101,0.75)",
    "-webkit-box-shadow": "0px 5px 5px 0px rgba(15,44,101,0.75)",
    "-moz-box-shadow": "0px 5px 5px 0px rgba(15,44,101,0.75)",
    cursor: "pointer",
  },
};

export const centered_flex_box = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const left_flex_box = {
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
};

export const right_flex_box = {
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
};

export const MainSearch = styled(TextField)(({ theme }) => ({
  "& label": {
    color: "var(--secColor) !important",
  },
  "& label.Mui-focused": {
    color: "var(--secColor) !important",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "green",
  },
  "& .MuiInputBase-input": {
    outerHeight: 500,
    color: "var(--secColor4)",
    textAlign: theme.direction === 'rtl' ? 'right' : 'left',
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      border: "1px solid var(--secColor)",
    },
    "&.Mui-focused fieldset": {
      borderColor: "var(--terColor)",
    },
    borderRadius: 50,
  },
}));

export const MainInput = styled(TextField)(({ theme }) => ({
  "& label": {
    color: "var(--secColor4) !important",

  },
  "& label.Mui-focused": {
    color: "var(--secColor4) !important",

  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "green",
  },
  "& .MuiInputBase-input": {
    outerHeight: 500,
    color: "var(--secColor4)",

  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      border: "1px solid var(--secColor4)",
    },
    "&.Mui-focused fieldset": {
      borderColor: "var(--terColor)",
    },
    borderRadius: 0,
  },
}));

export const MainDateInput = styled(DatePicker)(({ theme }) => ({
  "& label": {
    color: "var(--secColor) !important",
  },
  "& label.Mui-focused": {
    color: "var(--secColor) !important",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "green",
  },
  "& .MuiInputBase-input": {
    outerHeight: 500,
    color: "var(--secColor4)",
    textAlign: theme.direction === 'rtl' ? 'right' : 'left',
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      border: "1px solid var(--secColor)",
    },
    "&.Mui-focused fieldset": {
      borderColor: "var(--terColor)",
    },

    borderRadius: 0,
  },
}));

export const MainDateTimeInput = styled(DateTimePicker)(({ theme }) => ({
  "& label": {
    color: "var(--secColor) !important",
  },
  "& label.Mui-focused": {
    color: "var(--secColor) !important",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "green",
  },
  "& .MuiInputBase-input": {
    outerHeight: 500,
    color: "var(--secColor4)",
    textAlign: theme.direction === 'rtl' ? 'right' : 'left',
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      border: "1px solid var(--secColor)",
    },
    "&.Mui-focused fieldset": {
      borderColor: "var(--terColor)",
    },

    borderRadius: 0,
  },
}));

export const SecInput = styled(TextField)(({ theme }) => ({
  "& label": {
    color: "var(--appBg) !important",

  },
  "& label.Mui-focused": {
    color: "var(--appBg) !important",

  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "green",
  },
  "& .MuiInputBase-input": {
    outerHeight: 500,

  },
  "& .MuiOutlinedInput-root": {
    color: "var(--appBg) !important",
    "& fieldset": {
      border: "1px solid var(--primaryPurple)",
    },
    "&.Mui-focused fieldset": {
      borderColor: "var(--appBg)",
    },
    borderRadius: 0,
  },
}));

export const TerInput = styled(TextField)(({ theme }) => ({
  "& label": {
    color: "var(--appBg) !important",

  },
  "& label.Mui-focused": {
    color: "var(--appBg) !important",

  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "green",
  },
  "& .MuiInputBase-input": {
    outerHeight: 500,

  },
  "& .MuiOutlinedInput-root": {
    color: "var(--appBg) !important",
    "& fieldset": {
      border: "1px solid var(--secPurple)",
    },
    "&.Mui-focused fieldset": {
      borderColor: "var(--appBg)",
    },
    borderRadius: 0,
  },
}));

export const MainTextArea = ({
  name,
  autoComplete,
  autoFocus,
  label,
  id,
  required,
  lines,
  defaultValue,
}) => {
  return (
    <>
      <InputLabel sx={{ color: "black" }}>{label}</InputLabel>
      <TextArea
        name={name}
        autoComplete={autoComplete}
        defaultValue={defaultValue}
        autoFocus={autoFocus}
        id={id}
        aria-label={label}
        required={required}
        style={{
          borderColor: "var(--secColor)",
          borderRadius: 4,
          fontFamily: "sans-serif",
          backgroundColor: "var(--bgColor)",
          color: "var(--secColor)",
          height: { lines },
        }}
      />
    </>
  );
};

export const MainPassword = ({
  name,
  autoComplete,
  fullWidth,
  label,
  id,
  required,
  margin,
  sx,
  value,
  readOnly,
  error,
}) => {
  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <FormControl sx={{ width: "100%", ...sx }} variant="outlined">
      <InputLabel htmlFor="outlined-adornment-password" sx={{ color: "var(--secColor4) !important" }}>
        {label}
        {required ? "*" : ""}
      </InputLabel>
      <OutlinedInput
        sx={(theme) => ({
          "& fieldset": {
            border: "1px solid var(--secColor4)  !important",
          },
          "&.Mui-focused fieldset": {
            border: "2px solid var(--secColor4)  !important",
          },
          "& .MuiInputBase-input": {
            color: "var(--secColor4) !important",
            textAlign: theme.direction === 'rtl' ? 'right' : 'left',
          },
          borderRadius: 0
        })}
        id={id}
        name={name}
        margin={margin}
        required={required}
        autoComplete={autoComplete}
        fullWidth={fullWidth}
        type={showPassword ? "text" : "password"}
        readOnly={readOnly}
        value={value}
        error={error}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
              edge="end"
            >
              {showPassword ? (
                <VisibilityOff sx={{ color: "var(--secColor4)" }} />
              ) : (
                <Visibility sx={{ color: "var(--secColor4)" }} />
              )}
            </IconButton>
          </InputAdornment>
        }
        label={label}
      />
    </FormControl>
  );
};

export const SecPassword = ({
  name,
  autoComplete,
  fullWidth,
  label,
  id,
  required,
  margin,
  sx,
  value,
  readOnly,
  error,
}) => {
  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <FormControl sx={{ width: "100%", ...sx }} variant="outlined">
      <InputLabel
        sx={{ color: "var(--appBg) !important" }}
        htmlFor="outlined-adornment-password"
      >
        {label}
        {required ? "*" : ""}
      </InputLabel>
      <OutlinedInput
        sx={(theme) => ({
          color: "var(--appBg) !important",
          "& fieldset": {
            border: "1px solid var(--primaryPurple)",
          },
          "& .Mui-focused fieldset": {
            borderColor: "var(--appBg)",
          },
          "& .MuiInputBase-input": {
            textAlign: theme.direction === 'rtl' ? 'right' : 'left',
          },
          borderRadius: 0
        })}
        id={id}
        name={name}
        margin={margin}
        required={required}
        autoComplete={autoComplete}
        fullWidth={fullWidth}
        type={showPassword ? "text" : "password"}
        readOnly={readOnly}
        value={value}
        error={error}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
              edge="end"
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        }
        label={label}
      />
    </FormControl>
  );
};

export const MainInputLabel = ({ required, id, title, color }) => {
  return (
    <InputLabel sx={{ color }} required={required} id={id}>
      {title}
    </InputLabel>
  );
};
